var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"space-around"}},[_c('v-color-picker',{staticClass:"ma-2",attrs:{"hide-canvas":""}}),_c('v-color-picker',{staticClass:"ma-2",attrs:{"canvas-height":"300"}}),_c('v-color-picker',{staticClass:"ma-2",attrs:{"dot-size":"30"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }